import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleCalendarToNutshell from './icon-google-calendar-to-nutshell.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <GoogleCalendarToNutshell {...validProps} />;
}
SvgComponent.iconName = 'googleCalendarToNutshell';

/**
 * @deprecated This is a legacy icon
 */
export const GoogleCalendarToNutshellIcon = svgIconWrapper(SvgComponent);
